<template>
  <div class="page-container">
    <!-- 搜索栏 -->
    <div class="page-card">
      <div class="page-card__header">
        <span>预约公司（共{{ aSum }}人）</span>
      </div>

      <!-- 数据表格 -->
      <el-table :data="tableData" style="width: 100%; padding: 0 20px">
        <el-table-column prop="id" label="ID" width="50"></el-table-column>

        <el-table-column prop="wxuser.avatarurl" label="头像" width="80">
          <template slot-scope="scope">
            <el-image :src="logoUrl + scope.row.wxuser.avatarurl" style="width: 30px">
              <div slot="error">
                <i class="el-icon-picture-outline" style="font-size: 30px"></i>
              </div>
            </el-image>
          </template>
        </el-table-column>
        <el-table-column prop="wxuser.name" label="姓名" width="100"></el-table-column>
        <el-table-column prop="wxuser.company" label="所属公司"></el-table-column>
        <el-table-column prop="user.name" label="预约公司"></el-table-column>

        <el-table-column
          prop="create_time"
          label="时间"
          sortable
        ></el-table-column>
      </el-table>

      <!-- 分页器 -->
      <div class="pagination-wrap">
        <el-pagination
          @current-change="handleCurrentChange"
          :page-size="pagesize"
          :total="aSum"
          :page-count="pageCount"
          :current-page.sync="currentPage"
          background
          layout="prev, pager, next,jumper"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import api from "../../utils/api";

  export default {
    name: "viewerList",
    components: {
    },
    data() {
      return {
        // 头像基础地址
        logoUrl: "https://cloudexhibition.oss-cn-shenzhen.aliyuncs.com/avatar/",
        // 切换类型标识
        changetype: true,
        // 当前切换ID
        changeID: 0,
        // 表格命中数据
        tableDataHit: [],
        // 表格数据
        tableData: [],
        // 总条目数
        aSum: 0,
        // 当前页数
        currentPage: 1,
        // 总页数
        pageCount: 1,
        // 每页显示条目数
        pagesize: 10,

        // 命中数据总条目数
        aSum_hit: 0,
        // 命中数据当前页数
        currentPage_hit: 1,
        // 命中数据总页数
        pageCount_hit: 1,
        // 命中数据每页显示条目数
        pagesize_hit: 10,
      };
    },
    mounted() {
      // 页面加载时获取预约列表
      this.reserveList();
    },
    methods: {
      /**
       * 获取预约列表数据
       * 按创建时间倒序排列
       */
      reserveList() {
        let url = this.baseUrl + "/admin/reserves/?ordering=-create_time";
        api.fetchData(url).then((res) => {
          this.tableData = res.results;
          this.aSum = res.count;
          this.currentPage = 1;
        });
      },

      /**
       * 分页切换处理
       * @param {number} val - 目标页码
       */
      handleCurrentChange(val) {
        let url = this.baseUrl + "/admin/reserves/?ordering=-create_time&page=" + val;
        api.fetchData(url).then((res) => {
          this.tableData = res.results;
          this.aSum = res.count;
          this.currentPage = val;
        });
      },

      /**
       * 切换到默认页面视图
       */
      changePage() {
        this.changetype = true;
      },

      /**
       * 切换到命中页面视图
       */
      changePage_hit() {
        this.changetype = false;
      },

      /**
       * 删除预约记录
       * @param {object} row - 当前行数据
       */
      handleClick(row) {
        this.$confirm("将删除此条信息，是否继续", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          let a_id = row.id;
          let url = this.baseUrl + "/admin/visits/" + a_id + "/";
          api.deleteData(url).then((res) => {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.reserveList();
          });
        });
      },
    },
  };
</script>

<style scoped>
  .changtype {
    background-color: var(--color-primary);
    color: white;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/reservesList.vue